export default "__VITE_ASSET__L$98PqBW__"